module.exports = __webpack_public_path__ + "img/Contacts.91d9c0b8.png";